import React, { useState } from 'react';
import Routes from './routes'
import 'bootstrap/dist/css/bootstrap.min.css';
import './global.css';
import { getTheme, setTheme } from './services/auth';
import { ThemeContext } from './contexts/theme-context';
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./themes/theme";
import { ThemeProvider as ThemeProviderMUI } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

// const GlobalStyle = createGlobalStyle`
//   :root {
//     --main-bg-color: ${ props => props.theme.primary };
//     --main-white-color: ${ props => props.theme.white };
//     --main-secondy: ${ props => props.theme.secondy };
//     --main-secondy25: ${ props => props.theme.secondy25 };
//     --main-bg-D9: ${ props => props.theme.d9 };
//     --main-white-color-50: ${ props => props.theme.white50};
//     --main-white-color-60: ${ props => props.theme.white60};
//     --main-fundo: ${ props => props.theme.fundo};
//     --main-font: ${ props => props.theme.font};
//   }
// `;

const GlobalStyle = createGlobalStyle`
  :root {
    --main-bg-color: #00c496;
    --main-white-color: #fff;
    --main-secondy: #A5A5A5;
    --main-secondy25: #A5A5A525;
    --main-bg-D9: #A5A5A5;
    --main-white-color-50: #ffffff50;
    --main-white-color-60:  #ffffff60;
    --main-fundo: #fff;
    --main-font: #000;
  }
`;


function App() {
  // const [ isDarkTheme, setIsDarkTheme] = useState(getTheme() === 'dark')
  // const [theme, setTheme2] = useState(getTheme());
  const [ isDarkTheme, setIsDarkTheme] = useState(false)
  const [theme, setTheme2] = useState('light');
  function toggleTheme() {
    // setIsDarkTheme(isDark => !isDark);
    // let response = getTheme();
    // if(response !== undefined){
    //   if(response === "light"){
    //     setTheme('dark');
    //     setTheme2('dark');
    //   }else{
    //     setTheme('light');
    //     setTheme2('light');
    //   }
    // }else{
    //   setTheme(isDarkTheme ? 'light' : 'dark');
    //   setTheme2(isDarkTheme ? 'light' : 'dark');
    // }
  }
  // const themeMUI = React.useMemo(
  //   () =>
  //     createTheme({
  //       palette: {
  //         mode: theme,
  //       },
  //     }),
  //   [theme],
  // );
  return (
    <>
    {/* <ThemeProviderMUI theme={themeMUI}> */}
      {/* <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}> */}
        <GlobalStyle />
        {/* <ThemeContext.Provider value={{ theme, toggleTheme }}> */}
          <Routes />
        {/* </ThemeContext.Provider> */}
      {/* </ThemeProvider> */}
    {/* </ThemeProviderMUI> */}
    </>
  )
}

export default App
